import { AvailablePaymentMethods } from './available-payment-methods.model';
import { ICouponInfo } from './coupon-info.model';
import { PaymentFragment } from './payment-fragment.model';
import { PaymentStatus } from './payment-status.model';
import { LiabilitiesPaymentType } from '../../liabilities/models/liabilities-payment-type.enum';
import { PaymentMethodDetails } from './payment-method-details.model';

export class PaymentId {
  public paymentId: string;
}

export class Payment {
  public id: string;
  public paymentFragments: PaymentFragment[];
  public liabilitiesAmountToPaySum: number;
  public commission: number;
  public totalAmount: number;
  public couponAmount: number;
  public status: PaymentStatus;
  public availablePaymentMethods: AvailablePaymentMethods;
  public paymentMethodDetails: PaymentMethodDetails;
  public automaticPaymentAvailable: boolean;
  public automaticPaymentConfigured: boolean;
  public couponId: string;
  public couponInfo: ICouponInfo;
  public type: PaymentType;
  public unverifiedCustomerBillers: string[];
  public liabilitiesPaymentType: LiabilitiesPaymentType;
  public disabledExpressPaymentLiabilities: DisabledExpressPaymentLiability[];

  constructor() {
    this.paymentFragments = [];
  }
}

export interface DisabledExpressPaymentLiability {
  title: string;
  amountToPay: number;
  billerName: string;
  paymentDue: string;
}

export class BasePayment {
  public id: string;
  public status: PaymentStatus;
}

export class PaymentWithCoupon {
  public id: string;
  public totalAmount: number;
  public couponAmount: number;
  public status: PaymentStatus;
  public couponId: string;
  public couponInfo: ICouponInfo;
}

export enum PaymentType {
  STANDARD = 'STANDARD',
  EXPRESS = 'EXPRESS'
}

export interface PaymentWithPayer {
  payment: Payment | null;
}
